module.exports = __webpack_public_path__ + "static/media/klonopin.d30aa2c8.png";